import { ColorTypes } from '../ui/themes/_declarations/colors';

const FontBase = 16; // FontSize Base

/**
 * Converts a pixel value to a rem value.
 *
 * @param size - The pixel value to convert. This can be a number or a string.
 * If it's a string, it should end with 'px'. If it doesn't, the function will
 * treat the whole string as a number. If the value is not a number or a string,
 * the function will use the FontBase value.
 *
 * @returns The converted value in rem.
 */

export function pxToRem(size: number | string): string {
  let checksize;
  if (typeof size === 'number') {
    checksize = size;
  } else if (typeof size === 'string') {
    const len = size.indexOf('px') === -1 ? size.length : size.indexOf('px');
    checksize = parseInt(size.substring(0, len), 10);
  } else {
    checksize = FontBase;
  }

  const remSize = checksize / FontBase;
  return `${remSize}em`;
}

/**
 * Converts a color to an rgba color with a specified opacity.
 *
 * @param color - The color to convert. This can be a hex color (e.g. '#FFFFFF')
 * or an rgb color (e.g. 'rgb(255,255,255)'). If the color is in a different format,
 * the function may not work as expected.
 *
 * @param opacity - The opacity to apply. This should be a number between 0 and 1.
 *
 * @returns The color in rgba format with the specified opacity.
 */

export const colorOpacity = (color: string, opacity: number) => {
  if (color.includes('#')) {
    const R = parseInt(color.substring(1, 3), 16);
    const G = parseInt(color.substring(3, 5), 16);
    const B = parseInt(color.substring(5, 7), 16);

    return `rgba(${R},${G},${B},${opacity})`;
  }
  const colors = color
    .substring(color.indexOf('(') + 1, color.indexOf(')') - 1)
    .split(',');
  const R = parseInt(colors[0], 10);
  const G = parseInt(colors[1], 10);
  const B = parseInt(colors[2], 10);
  return `rgba(${R},${G},${B},${opacity})`;
};

type ButtonTheme = 'dark' | 'light';

const LANCIA = 'lancia';
const OPEL = 'opel';
const FIAT = 'fiat';
const CITROEN = 'citroen';
const PEUGEOT = 'peugeot';

const lightThemes = [LANCIA, OPEL, FIAT, CITROEN, PEUGEOT];

export const getThemeVariant: (theme: string) => ButtonTheme = (theme) =>
  lightThemes.includes(theme) ? 'light' : 'dark';

export const findColorKey = (
  color: ColorTypes,
  theme: ButtonTheme
): ColorTypes => {
  if (theme === 'light') {
    if (color.includes('dark')) {
      return color.replace('dark', 'light') as ColorTypes;
    }
    if (color.includes('Dark')) {
      return color.replace('Dark', 'Light') as ColorTypes;
    }
  } else if (theme === 'dark') {
    if (color.includes('light')) {
      return color.replace('light', 'dark') as ColorTypes;
    }
    if (color.includes('Light')) {
      return color.replace('Light', 'Dark') as ColorTypes;
    }
  }
  return color;
};
